import groupBy from 'lodash/groupBy';
import get from 'lodash/get';

export const degreeFilterOptions = [
  { value: 'associates', label: "Associate's" },
  { value: 'bachelors', label: "Bachelor's" },
  { value: 'certificates', label: 'Certificate' },
  { value: 'diploma', label: 'Diploma' },
  { value: 'doctorates', label: 'Doctorate' },
  { value: 'gradCertificates', label: 'Graduate Certificate' },
  { value: 'masters', label: "Master's" },
];

export const groupMajors = majors => {
  if (!Array.isArray(majors)) return [];

  majors.sort((a, b) => {
    const aAreaOfStudy = get(a, 'areaOfStudy.value', '');
    const bAreaOfStudy = get(b, 'areaOfStudy.value', '');
    const aMajorName = get(a, 'majorName.value', '');
    const bMajorName = get(b, 'majorName.value', '');

    return (
      aAreaOfStudy.localeCompare(bAreaOfStudy) || aMajorName.localeCompare(bMajorName)
    );
  });

  const groups = groupBy(majors, 'areaOfStudy.value');

  return Object.keys(groups).map(key => {
    const group = groups[key];

    const programs = group.map(program => {
      const majorName = get(program, 'majorName.value', '');
      const associates = get(program, 'degreeOffering.associates.value', false);
      const bachelors = get(program, 'degreeOffering.bachelors.value', false);
      const certificates = get(program, 'degreeOffering.certificates.value', false);
      const diploma = get(program, 'degreeOffering.diploma.value', false);
      const doctorates = get(program, 'degreeOffering.doctorates.value', false);
      const gradCertificates = get(
        program,
        'degreeOffering.gradCertificates.value',
        false,
      );
      const masters = get(program, 'degreeOffering.masters.value', false);

      return {
        majorName,
        degreeOffering: {
          associates,
          bachelors,
          certificates,
          diploma,
          doctorates,
          gradCertificates,
          masters,
        },
      };
    });

    return {
      areaOfStudy: key,
      programs,
    };
  });
};

export const filterMajorsByDegreeOffering = (majors, degreeFilter) => {
  if (!Array.isArray(majors)) return [];

  const result = [];

  if (!degreeFilterOptions.find(({ value }) => degreeFilter === value)) return majors;

  majors.forEach(major => {
    const programs = get(major, 'programs', []);

    const filteredPrograms = programs.filter(program => {
      const degreeOfferings = get(program, 'degreeOffering', {});

      if (
        degreeOfferings &&
        degreeFilter in degreeOfferings &&
        degreeOfferings[degreeFilter]
      ) {
        return true;
      }

      return false;
    });

    if (filteredPrograms.length > 0) {
      const filteredGroup = {
        ...major,
        programs: filteredPrograms,
      };

      result.push(filteredGroup);
    }
  });

  return result;
};

export const filterMajorsByKeyword = (majors, keywordFilter = '') => {
  if (!Array.isArray(majors)) return [];
  if (keywordFilter === '') return majors;

  const result = [];

  majors.forEach(major => {
    const areaOfStudy = get(major, 'areaOfStudy', '');

    if (areaOfStudy.toLocaleLowerCase().includes(keywordFilter.toLocaleLowerCase())) {
      result.push(major);
    } else {
      const programs = get(major, 'programs', []);

      const filteredPrograms = programs.filter(program => {
        const majorName = get(program, 'majorName', '');

        return majorName.toLocaleLowerCase().includes(keywordFilter.toLocaleLowerCase());
      });

      if (filteredPrograms.length > 0) {
        result.push({
          areaOfStudy,
          programs: filteredPrograms,
        });
      }
    }
  });

  return result;
};

export const filterMinorsByKeyword = (minors, keywordFilter = '') => {
  if (!Array.isArray(minors)) return [];

  return minors.filter(minor =>
    minor.toLocaleLowerCase().includes(keywordFilter.toLocaleLowerCase()),
  );
};

export const getAvailableDegreeOfferings = majors => {
  if (!Array.isArray(majors)) return [];

  const programs = majors.reduce((acc, item) => {
    const programs = get(item, 'programs', []);

    return acc.concat(programs);
  }, []);

  const result = [];

  programs.forEach(program => {
    const degreeOfferings = get(program, 'degreeOffering', {});

    degreeFilterOptions.forEach(option => {
      if (
        degreeOfferings[option.value] &&
        !result.find(({ value }) => option.value === value)
      ) {
        result.push(option);
      }
    });
  });

  return result;
};
